import { motion } from 'framer-motion'
import { item } from "../homepage/Section1"
import { IconSparkles } from '@tabler/icons-react'

const Section7 = () => {
  return (
    <div className='s7-partner' style={{backgroundColor : "#FFF6F3"}}>
        <div className='f-width m-auto'>
            <p className="s4-h-text text-center"><IconSparkles className="color-brand animate__animated animate__bounceIn animate__infinite animate__slower" width="34" height="34" /> How it works?</p>
            <motion.div variants={item} whileInView="visible" initial="hidden" className='row'>
                <div className='col-sm-12 col-lg-3'>
                    <div className='s7-p-card-content' style={{borderBottom: "2px solid #FF5E2C"}}>
                        <div className='bdr-top'></div>
                        <div className='brand-bg rounded-pill text-white step-1'>01</div>
                        <p className='s6-card-t1'>Submit the referral:</p>
                        <p className='s6-card-t2'>Share the client’s basics; we’ll take it from here.</p>
                    </div>
                </div>
                <div className='col-sm-12 col-lg-3'>
                    <div className='s7-p-card-content' style={{borderBottom: "2px solid #FF5E2C50"}}>
                        <div className='bdr-top'></div>
                        <div className='brand-bg rounded-pill text-white step-2'>02</div>
                        <p className='s6-card-t1'>Quick alignment call:</p>
                        <p className='s6-card-t2'>15–30 minutes to confirm goals and access.</p>
                    </div>
                </div>
                <div className='col-sm-12 col-lg-3'>
                    <div className='s7-p-card-content' style={{borderBottom: "2px solid #FF5E2C"}}>
                        <div className='bdr-top'></div>
                        <div className='brand-bg rounded-pill text-white step-3'>03</div>
                        <p className='s6-card-t1'>Plug & play setup:</p>
                        <p className='s6-card-t2'>No dev work needed; go live in days.</p>
                    </div>
                </div>
                <div className='col-sm-12 col-lg-3'>
                    <div className='s7-p-card-content' style={{borderBottom: "2px solid #FF5E2C50"}}>
                        <div className='bdr-top'></div>
                        <div className='brand-bg rounded-pill text-white step-4'>04</div>
                        <p className='s6-card-t1'>Track results & expand:</p>
                        <p className='s6-card-t2'>See dollars recovered, time saved, and more in your dashboard. </p>
                    </div>
                </div>
            </motion.div>
        </div>
    </div>
  )
}

export default Section7